import React from 'react'

import CircleSwapIcon from '@src/components/icons/CircleSwapIcon'
import PointIcon from '@src/components/icons/Point'
import SandDollarIcon from '@src/components/icons/SandDollar'

export const Rules: React.FC = () => {
    return (
        <div className='flex flex-col gap-4 pb-2'>
            {/* Daily Swapping Miles */}
            <div className='flex items-start gap-3'>
                <div className='flex items-center gap-2.5 rounded-xl bg-[#212326] p-3'>
                    <PointIcon height='24' width='24' />
                </div>
                <div className='flex flex-1 flex-col gap-1'>
                    <div className='text-base font-medium leading-6 text-white'>Daily Swapping Miles</div>
                    <div className='w-full text-sm font-medium leading-5 text-[#757575]'>
                        1,000 bonus Miles each day you place a trade. 1 Mile per $1 traded (up to 1mm/week).
                    </div>
                </div>
            </div>

            {/* Volume Miles */}
            <div className='flex items-start gap-3'>
                <div className='flex items-center gap-2.5 rounded-xl bg-[#212326] p-3'>
                    <CircleSwapIcon className='h-6 w-6 text-white' />
                </div>
                <div className='flex flex-1 flex-col gap-1'>
                    <div className='text-base font-medium leading-6 text-white'>Volume Miles</div>
                    <div className='w-full text-sm font-medium leading-5 text-[#757575]'>
                        3x Miles for non-stable routes, 5x Miles for emerging routes like Solana, Unichain, and more.
                        <br />
                        Cross-asset, non-stable swaps earn 50% more Miles.
                    </div>
                </div>
            </div>

            {/* Sand Dollars */}
            <div className='flex items-start gap-3'>
                <div className='flex items-center gap-2.5 rounded-xl bg-[#212326] p-3'>
                    <SandDollarIcon height='24' width='24' />
                </div>
                <div className='flex flex-1 flex-col gap-1'>
                    <div className='text-base font-medium leading-6 text-white'>Sand Dollars</div>
                    <div className='w-full text-sm font-medium leading-5 text-[#757575]'>
                        1 Sand Dollar for every $10,000 traded. You can exchange it for USDC at any time.
                    </div>
                </div>
            </div>
        </div>
    )
}
